const PLATFORM_CONFIG: Record<string, { name: string; color: string }> = {
  'chat.googleapis.com': { name: 'Google Chat', color: '#4285F4' },
  'hooks.slack.com': { name: 'Slack', color: '#4A154B' },
  'powerplatform.com': { name: 'Teams', color: '#6264A7' },
};

export const detectWebhookPlatform = (url: string): { name: string; color: string } | null => {
  const entry = Object.entries(PLATFORM_CONFIG).find(([pattern]) => url.includes(pattern));
  return entry ? entry[1] : null;
};
